module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-03-994bd93389fc9cf14ec7c81c4e9e5f99.svg";